export default "__VITE_ASSET__bDhtvQ8Z__"